import { motion } from 'framer-motion';
import imgIsolation from '@/assets/img-isolation.jpg';
import imgPermissions from '@/assets/img-permissions.jpg';
import imgAuditability from '@/assets/img-auditability.jpg';
import bgTech3 from '@/assets/bg-tech-3.jpg';

const pillars = [
  {
    image: imgIsolation,
    title: 'Agent Isolation',
    body: 'Every AI agent runs in a sandboxed environment to minimize blast radius and protect production systems.',
  },
  {
    image: imgPermissions,
    title: 'Policy-Gated Permissions',
    body: 'Enforce least-privilege access, scoped secrets, and approval rules for every agent action.',
  },
  {
    image: imgAuditability,
    title: 'Full Audit Visibility',
    body: 'Capture every prompt, action, and approval with complete traceability for security and compliance.',
  },
];

const SecuritySection = () => {
  return (
    <section id="security" className="section-padding relative overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <img src={bgTech3} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-background/75 backdrop-blur-sm" />
      </div>
      <div className="relative mx-auto max-w-7xl z-10">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
            Enterprise-grade agent security
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-muted-foreground">
            Deploy autonomous agents with confidence — isolation, policy controls, and audit trails
            are built into every session.
          </p>
        </motion.div>

        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {pillars.map((pillar, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="glass-card rounded-2xl overflow-hidden text-center"
            >
              <img
                src={pillar.image}
                alt={pillar.title}
                className="w-full h-44 object-cover"
                loading="lazy"
              />
              <div className="p-8">
                <h3 className="text-base font-semibold text-foreground">{pillar.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{pillar.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SecuritySection;
